import { useTranslation } from "react-i18next";
import {
  MyOrderStatusColors,
  MyPaymentStatusColors,
} from "../../../../../constants/order-status-enums";
import styles from "./Summary.module.css";
import { Uniter } from "../../../../../helbest";

const Summary = (props) => {
  const {
    id,
    number,
    created,
    status,
    paid_amount,
    payable_amount,
    total_price,
    total_discount,
    tax,
    shipping_price,
    payment_status,
    currency,
  } = props;
  const { t } = useTranslation();

  return (
    <div className={styles.BoxSummary} key={id}>
      <div className={styles.Content}>
        <div>
          <span className={styles.ContentTitle}>{t("summary.order_date")}</span>
          <span>{created}</span>
        </div>
        <div>
          <span className={styles.ContentTitle}>{t("summary.order_id")}</span>
          <span title={number} className={styles.IDField}>
            {number}
          </span>
        </div>
        <div>
          <span className={styles.ContentTitle}>{t("common.status")}</span>
          <span style={{ color: MyOrderStatusColors[status] }}>
            {t(`order.${status}`)}
          </span>
        </div>
        <div>
          <span className={styles.ContentTitle}>
            {t("detailmodel.payment_status")}
          </span>
          <span style={{ color: MyPaymentStatusColors[payment_status] }}>
            {t(`order.${payment_status}`)}
          </span>
        </div>
        <div>
          {t("summery.price")}
          <Uniter unit={currency} className={styles.Unit_Amount}>
            {total_price}
          </Uniter>
        </div>

        <div>
          {t("summery.discount")}
          <Uniter unit={currency} className={styles.Unit_Amount}>
            {total_discount}
          </Uniter>
        </div>

        <div>
          {t("summary.tax")}
          <Uniter unit={currency} className={styles.Unit_Amount}>
            {tax}
          </Uniter>
        </div>
        <div>
          {t("summary.shipping_price")}
          <Uniter unit={currency} className={styles.Unit_Amount}>
            {shipping_price}
          </Uniter>
        </div>
        <div>
          {t("summary.paid_amount")}
          <Uniter unit="OMR" className={styles.Unit_Amount}>
            {paid_amount}
          </Uniter>
        </div>
        <div className={`${styles.Seprator} mt-1`} />

        <div className={styles.PaidAmount}>
          {t("summery.payable")}
          <Uniter unit={currency} isBold unit_bold>
            {payable_amount}
          </Uniter>
        </div>
      </div>
    </div>
  );
};

export default Summary;